import { AgoraClient, AgoraClientOptions, AgoraEventHandler } from "@/agora";
import { RealtimeClient } from "@/ws";
import { RealtimeHandlerMap } from "@/ws";

export interface RoomOptions {
  agora: AgoraClientOptions;
}

export abstract class BaseRoomManager<T extends RealtimeClient> {
  agoraClient!: AgoraClient;
  options!: RoomOptions;
  WSClient!: T;

  abstract join(options: {
    classId: string;
    studentId?: string;
    teacherId?: string;
    camera?: boolean;
    microphone?: boolean;
    callingEventHandlers: AgoraEventHandler;
  }): Promise<any>;

  /**
   * Register realtime event handlers
   */
  async registerRealtimeEventHandler(handlerMap: RealtimeHandlerMap) {
    return this.WSClient.registerRealtimeEventHandler(handlerMap);
  }

  setCamera(options: { enable: boolean; videoEncoderConfigurationPreset?: string }) {
    return this.agoraClient.setCamera(options);
  }

  setMicrophone(options: { enable: boolean }) {
    return this.agoraClient.setMicrophone(options);
  }

  updateCameraDevice() {
    return this.agoraClient.updateCameraDevice();
  }

  updateMicrophoneDevice() {
    return this.agoraClient.updateMicrophoneDevice();
  }

  async updateSpeakerDevice() {
    return this.agoraClient.updateSpeakerDevice();
  }

  async updateAudioAndVideoFeed(cameras: Array<string>, audios: Array<string>) {
    await this.agoraClient.updateAudioAndVideoFeed(cameras, audios);
  }

  async close() {
    return this.agoraClient.reset();
  }
}
